var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMortarboard02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5C2 9.84178 10.0949 13.5 11.9861 13.5C13.8772 13.5 21.9722 9.84178 21.9722 8.5C21.9722 7.15822 13.8772 3.5 11.9861 3.5C10.0949 3.5 2 7.15822 2 8.5Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99414 11.5L6.23925 17.1299C6.24415 17.2426 6.25634 17.3555 6.28901 17.4635C6.38998 17.7973 6.57608 18.1006 6.86 18.3044C9.08146 19.8985 14.8901 19.8985 17.1115 18.3044C17.3956 18.1006 17.5816 17.7973 17.6826 17.4635C17.7152 17.3555 17.7274 17.2426 17.7324 17.1299L17.9774 11.5",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4734 10V17M20.4734 17C19.6814 18.4463 19.3312 19.2212 18.9755 20.5C18.8983 20.955 18.9596 21.1843 19.2732 21.3879C19.4006 21.4706 19.5537 21.5 19.7055 21.5H21.2259C21.3876 21.5 21.5507 21.4663 21.6838 21.3745C21.9753 21.1735 22.0503 20.953 21.9713 20.5C21.6595 19.3126 21.2623 18.5008 20.4734 17Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortarboard02);
export default __webpack_public_path__ + "static/media/mortarboard-02.b137a1c685d1644d772793a30edb593d.svg";
export { ForwardRef as ReactComponent };